import { type LocalizedPaths, samePathForAllLocales } from './site';

export const MENTOR_LANDING_PATHS: LocalizedPaths = {
  fr: '/fr/devenir-mentor',
  en: '/en/become-a-mentor'
};

/** Public, indexable pages that don't depend on catalog data. */
export const STATIC_PUBLIC_PAGES: {
  paths: LocalizedPaths;
  priority: number;
  changeFrequency: 'daily' | 'weekly' | 'monthly' | 'yearly';
}[] = [
  { paths: samePathForAllLocales(''), priority: 1, changeFrequency: 'daily' },
  { paths: MENTOR_LANDING_PATHS, priority: 0.9, changeFrequency: 'monthly' },
  { paths: samePathForAllLocales('/search'), priority: 0.8, changeFrequency: 'daily' },
  { paths: samePathForAllLocales('/faq'), priority: 0.5, changeFrequency: 'monthly' },
  { paths: samePathForAllLocales('/terms-conditions'), priority: 0.2, changeFrequency: 'yearly' },
  { paths: samePathForAllLocales('/privacy-policy'), priority: 0.2, changeFrequency: 'yearly' }
];

/** Authenticated or transactional areas crawlers should skip (`*` = locale segment). */
export const PRIVATE_PATH_PATTERNS = [
  '/api/',
  '/auth/',
  '/*/admin',
  '/*/agenda',
  '/*/bookings',
  '/*/dashboard',
  '/*/notifications',
  '/*/onboarding',
  '/*/settings',
  '/*/unauthorized',
  '/*/activity/create',
  '/*/activity/*/edit',
  '/*/activity/*/slots',
  '/*/activity/preview',
  '/*/activity/private',
  '/*/activity/success'
];
